import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { config } from '../../shared/smartadmin.config';
import { Observable } from 'rxjs/Observable';
import { Console } from '@angular/core/src/console';

@Injectable()
export class AseguradoraApiService {


  aseguradoras: any[] = [];

  aseguradoraURL: string = config.API_DATA_URL + '/aseguradora';

  constructor(public http: HttpClient) {}

  public getAseguradoras(): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.aseguradoraURL, { headers })
    .map( (aseguradoras: any) => {
        this.aseguradoras = aseguradoras;
        return this.aseguradoras;
      })
    .catch(this.handleError)
  }

  private getBaseUrl() {
    return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/'
  }

  private getHeaders(): HttpHeaders {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/aseguradora-api.service.ts